module.exports = __webpack_public_path__ + "static/07-0dd408839d72c198d972e07b36381a81.jpg";